export default "__VITE_ASSET__DwlT1K40__"